import { call, takeLatest } from "redux-saga/effects";
import {
    loadApprovalHistory,
    loadApproveActionLogs,
} from "./approvalHistoryModal.api";
import noop from "lodash.noop";
import {
    LOAD_REQUESTED,
    failLoadApprovalHistoryModal,
    successLoadApprovalHistoryModal,
} from "./approvalHistoryModal.duck";
import {
    getId,
    injectApiWithContextFactory,
    injectBoundActionCreatorsFactory,
} from "Utils/sagaUtils";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";

export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        successLoadApprovalHistoryModal,
        failLoadApprovalHistoryModal,
    },
    getId
);

export const withApiContext = injectApiWithContextFactory(
    {
        loadApprovalHistory,
        loadApproveActionLogs,
    },
    injectBoundGQLClient
);

function* loadRequested({
    api: { loadApprovalHistory = noop },
    actions: { successLoadApprovalHistoryModal, failLoadApprovalHistoryModal },
    resolve = noop,
    reject = noop,
}) {
    try {
        const approvalHistoryEdges = yield loadApprovalHistory();
        yield successLoadApprovalHistoryModal(approvalHistoryEdges);
        yield call(resolve);
    } catch (error) {
        yield failLoadApprovalHistoryModal(error);
        yield call(reject, error);
    }
}

function* loadApprovedActionRequested({
    api: { loadApproveActionLogs = noop },
    actions: { successLoadApprovalHistoryModal, failLoadApprovalHistoryModal },
    resolve = noop,
    reject = noop,
}) {
    try {
        const approvalHistoryEdges = yield loadApproveActionLogs();
        yield successLoadApprovalHistoryModal(approvalHistoryEdges);
        yield call(resolve);
    } catch (error) {
        yield failLoadApprovalHistoryModal(error);
        yield call(reject, error);
    }
}

export default () =>
    function* rootSaga() {
        yield takeLatest(
            LOAD_REQUESTED,
            withBoundActions(withApiContext(loadApprovedActionRequested))
        );
    };
